import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.6693 6.66732V10.0007C14.6693 13.334 13.3359 14.6673 10.0026 14.6673H6.0026C2.66927 14.6673 1.33594 13.334 1.33594 10.0007V6.00065C1.33594 2.66732 2.66927 1.33398 6.0026 1.33398H9.33594",
		stroke: "#6A4BC0",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.6693 6.66732H12.0026C10.0026 6.66732 9.33594 6.00065 9.33594 4.00065V1.33398L14.6693 6.66732Z",
		stroke: "#6A4BC0",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDocument;
